<div class="full-page">
    <div class="d-flex justify-content-between">
        <div class="col col-lg-6 main-image p-0">
            <img
                src="/assets/LOGIN/Image_login{{ client }}.png"
                style="height: 100vh; width: 50vw; object-fit: cover"
            />
        </div>

        <div class="col col-lg-6">
            <div class="login">
                <div class="text-center">
                    <img
                        src="/assets/logo/logo{{ client }}.png"
                        width="200"
                        height="60"
                        style="object-fit: contain"
                    />
                    <div class="connect">
                        <ng-container *ngIf="client === '-ironside'; else elseTemplateLogo">
                            <span
                                ><strong>{{ 'Password renewal' }}</strong></span
                            >
                        </ng-container>
                        <ng-template #elseTemplateLogo>
                            <span
                                ><strong>{{ 'Renouvellement de mot de passe' }}</strong></span
                            >
                        </ng-template>
                    </div>
                    <ng-container *ngIf="!loaded && !error">
                        <div class="mt-5 text-center">
                            <p class="mx-auto" style="font-size: 15px">{{ responseMessage }}</p>
                            <button mat-raised-button class="btn-primary" (click)="backLogin()">
                                {{
                                    client === '-ironside'
                                        ? 'Back to login'
                                        : ('Retour login' | uppercase)
                                }}
                            </button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="error">
                        <div class="mt-5 text-center">
                            <p class="mx-auto">
                                {{ "Une erreur s'est produite. Veuillez réessayer plus tard." }}
                            </p>
                            <button mat-raised-button class="btn-primary" (click)="backLogin()">
                                {{ 'Retour login' | uppercase }}
                            </button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="loaded">
                        <div class="Saisissez mt-5">
                            <ng-container
                                *ngIf="client === '-ironside'; else elseTemplateDescription"
                            >
                                {{
                                    'Your password must contain at least 8 characters, including at least 1 digit and 1 special character.'
                                }}
                            </ng-container>
                            <ng-template #elseTemplateDescription>
                                <p
                                    class="w-75 mx-auto"
                                    [style.color]="!validPassword ? '#FF3030' : ''"
                                >
                                    {{
                                        'Votre mot de passe doit contenir au moins 8 caractères dont 1 chiffre et 1 caractère spécial minimum'
                                    }}
                                </p>
                            </ng-template>

                            <p
                                class="w-75 mx-auto"
                                [style.color]="!passwordMatch && outConfirm ? '#FF3030' : ''"
                                [style.visibility]="
                                    outConfirm && !passwordMatch ? 'visible' : 'hidden'
                                "
                            >
                                <ng-container
                                    *ngIf="client === '-ironside'; else elseTemplateMessageError"
                                >
                                    {{
                                        'The two passwords are different, please enter the same password'
                                    }}
                                </ng-container>
                                <ng-template #elseTemplateMessageError>
                                    {{
                                        'Les deux
                                mots de passes sont différents, veuillez écrire le même mot de passe'
                                    }}
                                </ng-template>
                            </p>
                        </div>
                        <form [formGroup]="form">
                            <div class="formulaire">
                                <div>
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            <ng-container
                                                *ngIf="
                                                    client === '-ironside';
                                                    else elseTemplateLabel
                                                "
                                            >
                                                {{ 'New password' }}</ng-container
                                            >
                                            <ng-template #elseTemplateLabel>
                                                {{ 'Nouveau mot de passe' }}</ng-template
                                            >
                                        </mat-label>
                                        <input
                                            matInput
                                            type="{{ hidePassword ? 'password' : 'text' }}"
                                            name="password"
                                            formControlName="password"
                                            (focusout)="outPassword = true"
                                        />
                                        <button
                                            mat-icon-button
                                            matSuffix
                                            (click)="hidePassword = !hidePassword"
                                            [attr.aria-label]="
                                                hidePassword ? 'Hide password' : 'Show password'
                                            "
                                            [attr.aria-pressed]="hidePassword"
                                            style="color: gray"
                                            type="button"
                                        >
                                            <mat-icon>{{
                                                hidePassword ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div>
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            <ng-container
                                                *ngIf="
                                                    client === '-ironside';
                                                    else elseTemplateLabel
                                                "
                                            >
                                                {{ 'Confirm password' }}</ng-container
                                            >
                                            <ng-template #elseTemplateLabel>
                                                {{ 'Confirmation du mot de passe' }}</ng-template
                                            >
                                        </mat-label>
                                        <input
                                            matInput
                                            type="{{ hideConfirm ? 'password' : 'text' }}"
                                            name="confirmPassword"
                                            formControlName="confirmPassword"
                                            (focusout)="outConfirm = true"
                                        />
                                        <button
                                            mat-icon-button
                                            matSuffix
                                            (click)="hideConfirm = !hideConfirm"
                                            [attr.aria-label]="
                                                hideConfirm ? 'Hide password' : 'Show password'
                                            "
                                            [attr.aria-pressed]="hideConfirm"
                                            style="color: gray"
                                            type="button"
                                        >
                                            <mat-icon>{{
                                                hideConfirm ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div style="margin-top: 2vh">
                                    <button
                                        type="submit"
                                        class="btn-primary"
                                        mat-raised-button
                                        (click)="changePassword()"
                                        [disabled]="form.invalid || !passwordMatch"
                                    >
                                        <ng-container
                                            *ngIf="client === '-ironside'; else elseTemplateButton"
                                        >
                                            {{ 'Send' }}</ng-container
                                        >
                                        <ng-template #elseTemplateButton>
                                            {{ 'Valider' }}</ng-template
                                        >
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                    <div class="socials my-3">
                        <div class="d-flex justify-content-between">
                            <a href="{{ env.facebook_url }}" target="_blank" class="fa fa-facebook"
                                ><svg
                                    height="100%"
                                    style="
                                        fill-rule: evenodd;
                                        clip-rule: evenodd;
                                        stroke-linejoin: round;
                                        stroke-miterlimit: 2;
                                    "
                                    version="1.1"
                                    viewBox="0 0 512 512"
                                    width="100%"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:serif="http://www.serif.com/"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <path
                                        d="M374.245,285.825l14.104,-91.961l-88.233,0l0,-59.677c0,-25.159 12.325,-49.682 51.845,-49.682l40.117,0l0,-78.291c0,0 -36.408,-6.214 -71.214,-6.214c-72.67,0 -120.165,44.042 -120.165,123.775l0,70.089l-80.777,0l0,91.961l80.777,0l0,222.31c16.197,2.542 32.798,3.865 49.709,3.865c16.911,0 33.512,-1.323 49.708,-3.865l0,-222.31l74.129,0Z"
                                        style="fill: #0373bc; fill-rule: nonzero"
                                    /></svg
                            ></a>

                            <a href="{{ env.twitter_url }}" target="_blank" class="fa fa-twitter"
                                ><svg
                                    height="100%"
                                    style="
                                        fill-rule: evenodd;
                                        clip-rule: evenodd;
                                        stroke-linejoin: round;
                                        stroke-miterlimit: 2;
                                    "
                                    version="1.1"
                                    viewBox="0 0 512 512"
                                    width="100%"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:serif="http://www.serif.com/"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <rect
                                        height="400"
                                        style="fill: none"
                                        width="400"
                                        x="56"
                                        y="56"
                                    />
                                    <path
                                        d="M161.014,464.013c193.208,0 298.885,-160.071 298.885,-298.885c0,-4.546 0,-9.072 -0.307,-13.578c20.558,-14.871 38.305,-33.282 52.408,-54.374c-19.171,8.495 -39.51,14.065 -60.334,16.527c21.924,-13.124 38.343,-33.782 46.182,-58.102c-20.619,12.235 -43.18,20.859 -66.703,25.498c-19.862,-21.121 -47.602,-33.112 -76.593,-33.112c-57.682,0 -105.145,47.464 -105.145,105.144c0,8.002 0.914,15.979 2.722,23.773c-84.418,-4.231 -163.18,-44.161 -216.494,-109.752c-27.724,47.726 -13.379,109.576 32.522,140.226c-16.715,-0.495 -33.071,-5.005 -47.677,-13.148l0,1.331c0.014,49.814 35.447,93.111 84.275,102.974c-15.464,4.217 -31.693,4.833 -47.431,1.802c13.727,42.685 53.311,72.108 98.14,72.95c-37.19,29.227 -83.157,45.103 -130.458,45.056c-8.358,-0.016 -16.708,-0.522 -25.006,-1.516c48.034,30.825 103.94,47.18 161.014,47.104"
                                        style="fill: #0373bc; fill-rule: nonzero"
                                    /></svg
                            ></a>

                            <a
                                href="{{ env.instagram_url }}"
                                target="_blank"
                                class="fa fa-instagram"
                            >
                                <svg
                                    fill="#0373BC"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 26 26"
                                    width="100%"
                                    height="100%"
                                >
                                    <path
                                        d="M 7.546875 0 C 3.390625 0 0 3.390625 0 7.546875 L 0 18.453125 C 0 22.609375 3.390625 26 7.546875 26 L 18.453125 26 C 22.609375 26 26 22.609375 26 18.453125 L 26 7.546875 C 26 3.390625 22.609375 0 18.453125 0 Z M 7.546875 2 L 18.453125 2 C 21.527344 2 24 4.46875 24 7.546875 L 24 18.453125 C 24 21.527344 21.53125 24 18.453125 24 L 7.546875 24 C 4.472656 24 2 21.53125 2 18.453125 L 2 7.546875 C 2 4.472656 4.46875 2 7.546875 2 Z M 20.5 4 C 19.671875 4 19 4.671875 19 5.5 C 19 6.328125 19.671875 7 20.5 7 C 21.328125 7 22 6.328125 22 5.5 C 22 4.671875 21.328125 4 20.5 4 Z M 13 6 C 9.144531 6 6 9.144531 6 13 C 6 16.855469 9.144531 20 13 20 C 16.855469 20 20 16.855469 20 13 C 20 9.144531 16.855469 6 13 6 Z M 13 8 C 15.773438 8 18 10.226563 18 13 C 18 15.773438 15.773438 18 13 18 C 10.226563 18 8 15.773438 8 13 C 8 10.226563 10.226563 8 13 8 Z"
                                    /></svg
                            ></a>

                            <a href="{{ env.youtube_url }}" target="_blank" class="fa fa-youtube"
                                ><svg
                                    height="100%"
                                    width="100%"
                                    version="1.1"
                                    id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 461.001 461.001"
                                    xml:space="preserve"
                                >
                                    <g>
                                        <path
                                            style="fill: #0373bc"
                                            d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728
                                    c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137
                                C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607
                                c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"
                                        />
                                    </g></svg
                            ></a>

                            <a href="{{ env.linkedin_url }}" target="_blank" class="fa fa-linkedin"
                                ><svg
                                    height="100%"
                                    style="
                                        fill-rule: evenodd;
                                        clip-rule: evenodd;
                                        stroke-linejoin: round;
                                        stroke-miterlimit: 2;
                                    "
                                    version="1.1"
                                    viewBox="0 0 512 512"
                                    width="100%"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:serif="http://www.serif.com/"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <g id="g5891">
                                        <path
                                            d="M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z"
                                            id="background"
                                            style="fill: #0373bc"
                                        />
                                        <g id="shapes">
                                            <rect
                                                height="257.962"
                                                id="rect11"
                                                style="fill: #fff"
                                                width="85.76"
                                                x="61.053"
                                                y="178.667"
                                            />
                                            <path
                                                d="M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z"
                                                id="path13-0"
                                                style="fill: #fff; fill-rule: nonzero"
                                            />
                                            <path
                                                d="M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z"
                                                id="path15"
                                                style="fill: #fff; fill-rule: nonzero"
                                            />
                                        </g>
                                    </g></svg
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
